import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".handle",
      animation: 150,
      onEnd: this.endDrag.bind(this)
    })
  }

  endDrag(event) {
    let id = event.item.dataset.id
    if (this.hasUrlValue && id) {
      let data = new FormData()
      data.append("position", event.newIndex + 1)

      Rails.ajax({
        url: this.urlValue.replace(":id", id),
        type: 'PATCH',
        data: data
      })
    }
  }
}
